var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.supplier)?_c('div',[_c('supplier-details',{attrs:{"supplier":_vm.supplier},on:{"update:supplier":function($event){_vm.supplier=$event}}}),_c('br'),_c('supplier-products',{attrs:{"supplier":_vm.supplier}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }